export enum PurchaseRequestOptionDialogAction {
  DOWNLOAD_ORDER = 'download-order',
  UPLOAD_SPREADSHEET = 'upload-spreadsheet'
}

export interface PurchaseRequestOptionDialogResult {
  action: PurchaseRequestOptionDialogAction;
}
